export const ROUTE_HOME = "/";
export const ROUTE_MENU = "/menu";
export const ROUTE_DINE_IN_MENU = "/menu/dine-in";
export const ROUTE_ORDERS = "/orders";
export const ROUTE_REVIEW_ORDER = "/review-order";
export const ROUTE_RATE = "/rate";
export const ROUTE_DIGITAL_MENU = "/digital-menu";
export const ROUTE_CUSTOMER_FORM = "/customer-form";
export const ROUTE_TRACK_DELIVERY = "/track-delivery";

export const ROUTE_TAKEAWAY_MENU = "/menu?order_type=take-away";
export const ROUTE_DELIVERY_MENU = "/menu?order_type=delivery";

export const PAGE_TITLES: Record<string, string | undefined> = {
  "/": undefined,
  "/menu": "Menu",
  "/menu/item/[slug]": "Menu",
  "/menu/dine-in": "Dine-in Menu",
  "/digital-menu": "Digital Menu",
};
